<img [alt]="icon" [src]="gaIconSource" />
